module.exports = __webpack_public_path__ + "media/images/markup-images/noukaweb-logo-1x1-63a9206b90890d7781d15551d012eed0.jpg";